import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../assets/img/icon/Right.svg';
import SuraCard from '../../components/SuraCard';
import WhatsappDialog from '../CommonDialogs/WhatsappDialog.component';

const useStyle = makeStyles(() =>
  createStyles({
    card_description: {
      whiteSpace: 'nowrap',
      width: '350px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
);

const PolicyCard = ({ policy, navigate }: any) => {
  const classes = useStyle();
  const history = useHistory();
  const [open_dialog, setOpenWhatsappDialog] = useState(false);

  const validateCompany = (company, policy_id) => {
    // company.toLowerCase() == 'galicia' && navigate != '/documentation/product/'
    //   ? setOpenWhatsappDialog(true)
    //   : history.push(`${navigate}${policy_id}`);
    history.push(`${navigate}${policy_id}`);
  };

  let hasVehicles =
    !!policy?.vehicles &&
    Array.isArray(policy.vehicles) &&
    policy.vehicles.length > 0;
  let isFleet = hasVehicles && policy.vehicles.length > 2;
  let licensePlates: string = '';
  hasVehicles &&
    policy.vehicles.map((vehicle: any, index: number) => {
      const plate = vehicle.license_plate
        ? index === 0
          ? vehicle.license_plate
          : ` -  ${vehicle.license_plate}`
        : '';
      licensePlates = `${licensePlates} ${plate}`;
    });
  let description = policy?.product?.description;
  let policyDetails = `${description}${
    isFleet ? ': FLOTA / ' : hasVehicles ? ': Patente ' : ''
  }${licensePlates}`;

  return (
    <>
      <WhatsappDialog
        is_open={open_dialog}
        close_dialog={() => setOpenWhatsappDialog(false)}
        message={`En este momento no podemos mostrarte la información de tu póliza.
				Podés seguir operando vía Whatsapp.`}
      />

      <ButtonBase
        onClick={() => validateCompany(policy.provider.company, policy.id)}
        style={{ width: '100%' }}
      >
        <SuraCard>
          <Box p={3} pl={0} style={{ display: 'flex', width: '100%' }}>
            <Box ml={2} flex={5}>
              <Typography variant="body2" align="left">
                {' '}
                Póliza {policy.number}{' '}
              </Typography>
              <Box mt={1}>
                <Typography
                  color="secondary"
                  align="left"
                  className={classes.card_description}
                >
                  {' '}
                  {policyDetails}{' '}
                </Typography>
              </Box>
            </Box>

            <Box>
              <RightIcon />
            </Box>
          </Box>
        </SuraCard>
      </ButtonBase>
    </>
  );
};

export default PolicyCard;
